import { useState } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";

// Common
import Header from "./components/common/Header";
import Footer from "./components/common/Footer";

// Auth
import Login from "./components/auth/Login";
import Logout from "./components/auth/Logout";

// User Panel
import Sidebar from "./components/user/Sidebar";
import Gallery from "./pages/Media.js";
import Blogs from "./pages/Blogs.js";
import Categories from "./pages/Categories.js";
import Transcripts from "./pages/Transcript.js";

// Context & PrivateRoute
import { useAppContext } from "./context/AppContext.js";
import PrivateRoute from "./components/PrivateRoute.js";
import News from "./pages/News.js";
import Home from "./components/public/Home.js";
import Location from "./pages/Location.js";

function App() {
  const location = useLocation();
  const { state } = useAppContext();

  const { user, loading } = state;
  const isLoggedIn = !!state.user; // context-driven login check

  // console.log("Loggend in", isLoggedIn);

  // Optional: role if needed later
  const [role, setRole] = useState("");

  if (loading) {
    // While context is loading user info, show blank page or loader
    return <div>Loading...</div>;
  }

  return (
    <div className="App wrapper">
      {isLoggedIn && <Sidebar />}
      <div className={isLoggedIn ? "main-panel" : ""}>
        {isLoggedIn && <Header />}

        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/locations" element={<Location />} />

          {/* Protected Routes */}
          <Route element={<PrivateRoute />}>
            <Route path="/media" element={<Gallery />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route path="/categories" element={<Categories />} />
            {/* <Route path="/news" element={<News />} /> */}
            <Route path="/transcript" element={<Transcripts />} />
          </Route>

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

        {isLoggedIn && <Footer />}
      </div>
    </div>
  );
}

export default App;
